export const sizes = {
  footerHeight: 150,
};

export const colors = {
  background: '#252F34',
};
